import React from "react";
import { BottomWrapper } from "./MapStyled";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

const MapBottom = ({
    lat,
    lng,
    setLat,
    setLng,
    isValidLat,
    isValidLng,
    handleGoButtonClick,
    handleSetSiteExtentOpen
}) => {
    const { t } = useTranslation();
    return (
        <BottomWrapper className="display for-map-bottom ">
            <div className="divStyle">
                <Tooltip arrow open={isValidLat !== ""} title={isValidLat}>
                    <input
                        className="input"
                        type="text"
                        value={lat}
                        onChange={(e) => setLat(e.target.value)}
                        placeholder={t("Enter_Latitude")}
                    />
                </Tooltip>
                <Tooltip arrow open={isValidLng !== ""} title={isValidLng}>

                    <input
                        className="input"
                        type="text"
                        value={lng}
                        onChange={(e) => setLng(e.target.value)}
                        placeholder={t("Enter_Longitude")}
                    />
                </Tooltip>
                <button className="tags" onClick={handleGoButtonClick}>Go</button>
                <button className="tags" onClick={handleSetSiteExtentOpen}>{t("Set_Extents")}</button>
            </div>
        </BottomWrapper>
    );
};

export default MapBottom;
